import React from "react";
import "../css/Service.css";
import Review from "./review";

const services = [
  {
    title: "Hazardous Waste",
    description: "Nationwide hazardous waste management, recycling, and compliant disposal.",
    link: "/services/hazardous-waste",
    icon: "☣️",
  },
  {
    title: "Medical Waste",
    description: "Medical waste management and compliant disposal services.",
    link: "/services/medical-waste",
    icon: "🧪",
  },
  {
    title: "Chemical Waste",
    description: "Lab packs, recycling, and EPA-compliant chemical disposal.",
    link: "/services/chemical-waste",
    icon: "⚗️",
  },
  {
    title: "Industrial & Healthcare Laundry",
    description: "Medical-grade laundering, UV-C finishing and RFID-tracked linen management.",
    link: "/services/laundry-service",
    icon: "🧺",
  },
  {
    title: "Autoclave & Advanced Processing",
    description: "Autoclave sterilization, shredding and pre-treatment prior to incineration.",
    link: "/services/autoclave",
    icon: "🛠️",
  },
  {
    title: "Manufacturing",
    description: "Custom-built incinerators, autoclaves, and medical-grade equipment.",
    link: "/services/manufacturing",
    icon: "🏗️",
  },
  {
    title: "Liquid Waste",
    description: "On-site collection and EPA-approved treatment for liquid wastes.",
    link: "/services/liquid-waste",
    icon: "💧",
  },
  {
    title: "Non-Hazardous Waste",
    description: "Collection, recycling, and responsible disposal for non-hazardous streams.",
    link: "/services/non-hazardous-waste",
    icon: "🗑️",
  },
  {
    title: "Industrial Waste",
    description: "RCRA-compliant industrial waste management, recycling, and disposal.",
    link: "/services/industrial-waste",
    icon: "🏭",
  },
  {
    title: "Organic Waste",
    description: "Composting, collection, and recycling solutions for food, green, and wood wastes.",
    link: "/services/organic-waste",
    icon: "🌿",
  },
  {
    title: "Other Waste",
    description: "Recycling and disposal solutions for specialty waste and packaging streams.",
    link: "/services/other-waste",
    icon: "📦",
  },
];

function Service() {
  return (
    <div className="service-page">
        <div className="service-banner">
          <img
            src={'/img_10.748Z.png'}
            alt="Service Banner"
            className="service-banner-img"
          />
          <div className="service-banner-overlay"></div>
          <div className="service-banner-content">
            <h1> Our Services</h1>
          </div>
        </div>

      <header className="service-header">
        <h1>Clean World: Your Trusted Partner in Waste Management</h1>
        <p>
          At Clean World, we are committed to delivering high-quality, compliant waste management services tailored to your operational needs. Our team combines technical expertise with safe, sustainable solutions.
        </p>
      </header>
      <div className="service-cards">
        {services.map((service, idx) => (
          <a href={service.link} className="service-card" key={idx}>
            <div className="service-icon">{service.icon}</div>
            <h2>{service.title}</h2>
            <p>{service.description}</p>
            <span className="service-link">Learn More &rarr;</span>
          </a>
        ))}
      </div>
      <footer className="service-footer">
      {/**  <p>
          With Shoreham Drugs, you can count on professional care, reliable service, and a seamless pharmacy experience.
        </p> */}
      </footer>
      <Review/>
    </div>
  );
}

export default Service;